<template>
	<header>
		<div
			class="topnav top"
			:class="
				showTopNav || $store.getters.layout == 'Mobile' ? '' : 'showborder'
			"
		>
			<div class="topnav__left">
				<button class="topnav__menu" @click="showOverlayMenu = true">
					<svg
						id="Layer_1"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5 6H19"
							stroke="var(--dark-blue)"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M5 12H15"
							stroke="var(--dark-blue)"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M5 18H19"
							stroke="var(--dark-blue)"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
				</button>
				<logo @click.native="goTo('/', 'home')" />
			</div>
			<div class="topnav__right">
				<div
					class="topnav__session__links visible-desktop"
					v-if="$auth.getAuthStatus()"
				>
					<notifications-icon />
					<router-link
						class="topnav__session__links__item"
						to="/mybets"
						active-class="active"
						exact
						replace
					>
						<svg
							class="topnav__session__links__item__icon"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect
								x="4"
								y="4"
								width="15.5"
								height="16"
								rx="5"
								stroke-width="1.5"
								stroke-linejoin="round"
							/>
							<path
								d="M8.44434 8.88892H11.5816"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
							<path
								d="M8.44434 12H15.111"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
							<path
								d="M8.44434 15.1111H15.111"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
						</svg>

						<span class="nav__item__label">My Bets</span>
					</router-link>
					<router-link
						class="topnav__session__links__item"
						to="/profile"
						active-class="active"
						exact
						replace
					>
						<svg
							class="topnav__session__links__item__icon"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<circle
								cx="12"
								cy="7"
								r="3"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
							<path
								d="M18 17C18 19.7614 14.7614 20 12 20C9.23858 20 6 19.7614 6 17C6 14.2386 9.23858 12 12 12C14.7614 12 18 14.2386 18 17Z"
								stroke-width="1.5"
								stroke-linecap="round"
							/>
						</svg>

						<span class="nav__item__label">Profile</span>
					</router-link>
				</div>
				<top-session-button />
				<div class="visible-desktop" style="padding: 0 15px">
					<toggle-button />
				</div>
				<search-icon class="visible-mobile" />
				<notifications-icon
					class="visible-mobile"
					v-show="$auth.getAuthStatus()"
				/>
			</div>
		</div>

		<!--		Notification banner - displays if message is in session variable notification-banner-message-->
		<div v-if="hasMessage && isAuthenticated">
			<notification-banner
				:name="'footer-notification-banner'"
				:dismissable="true"
				:advanced="message.advanced"
				:confirm-dismiss-forever="message.confirmDismissForever"
				:image="
					message.image
						? message.image
						: env.mobileUrl + '/static/images/icon-120x120.png'
				"
				:title="message.title"
				:message="message.msg"
				:action-label="message.actionLabel"
				:action-url="message.actionUrl"
				@click="(url) => bannerNotificationAction(url)"
			></notification-banner>
		</div>

		<div class="nav__container" v-show="showTopNav">
			<div class="nav">
				<router-link
					class="nav--item"
					:class="{
						'nav--item': 1,
						selected:
							[
								'home',
								'prebet-markets',
								'sport-countries',
								'sport',
								'sport-competition',
							].indexOf($route.name) > -1,
					}"
					:to="{ name: 'home' }"
				>
					Home
				</router-link>
				<router-link
					:class="{
						'nav--item': 1,
						selected: ['live', 'live-markets'].indexOf($route.name) > -1,
					}"
					:to="{ name: 'live' }"
					v-show="$store.getters.layout == 'Desktop'"
				>
					Live ({{ $store.getters.numberOfLiveMatches }})</router-link
				>

				<router-link
					:class="{
						'nav--item': 1,
						selected:
							[
								'jackpots',
								'grand-jackpot',
								'midweek-jackpot',
								'jackpot-results',
								'jackpot-result',
							].indexOf($route.name) > -1,
					}"
					:to="{ name: 'grand-jackpot' }"
					v-if="productAvailable('jackpots')"
				>
					Jackpots
				</router-link>
				<router-link
					class="nav--item"
					v-if="productAvailable('shikisha')"
					:to="`/${env.shikishaProductName.replace(/\s/, '-').toLowerCase()}`"
					:class="{
						selected:
							$route.path ==
							`/${env.shikishaProductName.replace(/\s/, '-').toLowerCase()}`,
					}"
				>
					{{ env.shikishaProductName }}
					{{
						numberOfBetBuilderMatches > 0
							? `(${numberOfBetBuilderMatches})`
							: ""
					}}
				</router-link>
				<router-link
					class="nav--item"
					v-if="productAvailable('livescore')"
					:class="{
						selected: ['livescore'].indexOf($route.name) > -1,
					}"
					:to="{ name: 'livescore' }"
				>
					Live Score
				</router-link>

				<a
					v-if="productAvailable('appLink')"
					class="nav--item"
					@click="goToApp"
				>
					<a :href="env.appLink" target="_blank" class="hide" :ref="'appLink'"
						>Download App</a
					>
					App
				</a>

				<router-link
					class="nav--item"
					to="/offers"
					v-if="productAvailable('offersNRewards')"
				>
					Offers
				</router-link>
				<router-link
					class="nav--item visible-desktop"
					v-if="productAvailable('goldenRace')"
					:to="{ name: 'betika-super-league' }"
					:class="{
						selected: ['betika-super-league'].indexOf($route.name) > -1,
					}"
				>
					Betika Super League
				</router-link>
				<router-link
					class="nav--item"
					v-if="productAvailable('virtuals')"
					:to="{ name: 'virtual' }"
					:class="{
						selected:
							[
								'virtual',
								'virtuals',
								'virtuals-markets',
								'virtuals-ongoing',
								'virtuals-results',
								'virtuals-table',
								'virtuals-matches',
							].indexOf($route.name) > -1,
					}"
				>
					Virtual
				</router-link>
				<router-link
					class="nav--item"
					v-if="productAvailable('splitPot')"
					:to="`/${env.splitPotName.replace(/\s/, '-').toLowerCase()}`"
					:class="{
						selected:
							$route.path ==
							`/${env.splitPotName.replace(/\s/, '-').toLowerCase()}`,
					}"
				>
					{{ env.splitPotName }}
				</router-link>
				<router-link
					class="nav--item"
					:to="{ name: 'casino' }"
					v-if="productAvailable('casino')"
					:class="{
						selected:
							['casino', 'casino-category', 'casino-game'].indexOf(
								$route.name
							) > -1,
					}"
				>
					Casino
				</router-link>
			</div>
			<a
				class="top-nav-link visible-desktop"
				v-if="env.helpLink"
				:href="env.helpLink"
				target="_blank"
			>
				<svg
					width="17"
					height="16"
					viewBox="0 0 17 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="top-nav-link__icon"
				>
					<path
						d="M8.5 0.25C9.875 0.25 11.1875 0.625 12.375 1.3125C13.5625 2 14.5 2.9375 15.1875 4.125C15.875 5.3125 16.25 6.625 16.25 8C16.25 9.40625 15.875 10.6875 15.1875 11.875C14.5 13.0625 13.5625 14.0312 12.375 14.7188C11.1875 15.4062 9.875 15.75 8.5 15.75C7.09375 15.75 5.8125 15.4062 4.625 14.7188C3.4375 14.0312 2.46875 13.0625 1.78125 11.875C1.09375 10.6875 0.75 9.40625 0.75 8C0.75 6.625 1.09375 5.3125 1.78125 4.125C2.46875 2.9375 3.4375 2 4.625 1.3125C5.8125 0.625 7.09375 0.25 8.5 0.25ZM8.5 14.25C9.625 14.25 10.6562 13.9688 11.625 13.4062C12.5625 12.8438 13.3438 12.0938 13.9062 11.125C14.4688 10.1875 14.75 9.125 14.75 8C14.75 6.875 14.4688 5.84375 13.9062 4.875C13.3438 3.9375 12.5625 3.15625 11.625 2.59375C10.6562 2.03125 9.625 1.75 8.5 1.75C7.375 1.75 6.3125 2.03125 5.375 2.59375C4.40625 3.15625 3.65625 3.9375 3.09375 4.875C2.53125 5.84375 2.25 6.875 2.25 8C2.25 9.125 2.53125 10.1875 3.09375 11.125C3.65625 12.0938 4.40625 12.8438 5.375 13.4062C6.3125 13.9688 7.375 14.25 8.5 14.25ZM11.8438 6.28125C11.8438 5.78125 11.6875 5.3125 11.375 4.875C11.0625 4.46875 10.6875 4.125 10.1875 3.875C9.6875 3.625 9.1875 3.5 8.6875 3.5C7.96875 3.5 7.375 3.65625 6.875 3.9375C6.375 4.21875 5.90625 4.625 5.53125 5.1875C5.46875 5.28125 5.46875 5.375 5.46875 5.46875C5.46875 5.59375 5.53125 5.65625 5.625 5.71875L6.5 6.375C6.5625 6.4375 6.65625 6.46875 6.75 6.4375C6.84375 6.4375 6.9375 6.375 7 6.3125C7.25 5.96875 7.5 5.71875 7.6875 5.59375C7.90625 5.46875 8.1875 5.375 8.5 5.375C8.8125 5.375 9.125 5.46875 9.375 5.625C9.625 5.8125 9.78125 6 9.78125 6.25C9.78125 6.4375 9.6875 6.625 9.5625 6.75C9.4375 6.875 9.21875 7 8.90625 7.1875L8.84375 7.21875C8.40625 7.46875 8.09375 7.6875 7.90625 7.875C7.5625 8.21875 7.40625 8.625 7.40625 9.09375V9.375C7.40625 9.5 7.4375 9.59375 7.5 9.65625C7.5625 9.71875 7.65625 9.75 7.78125 9.75H9.21875C9.3125 9.75 9.40625 9.71875 9.46875 9.65625C9.53125 9.59375 9.59375 9.5 9.59375 9.375V9.1875C9.59375 9.0625 9.65625 8.9375 9.8125 8.8125C9.875 8.75 10.0625 8.625 10.3125 8.46875C10.7812 8.21875 11.125 7.96875 11.3438 7.71875C11.6562 7.34375 11.8438 6.84375 11.8438 6.28125ZM9.8125 11.5C9.8125 11.1562 9.65625 10.8438 9.40625 10.5938C9.15625 10.3438 8.84375 10.1875 8.5 10.1875C8.125 10.1875 7.8125 10.3438 7.5625 10.5938C7.3125 10.8438 7.1875 11.1562 7.1875 11.5C7.1875 11.875 7.3125 12.1875 7.5625 12.4375C7.8125 12.6875 8.125 12.8125 8.5 12.8125C8.84375 12.8125 9.15625 12.6875 9.40625 12.4375C9.65625 12.1875 9.8125 11.875 9.8125 11.5Z"
					/>
				</svg>

				<span class="top-nav-link__text">Help & Support</span>
			</a>
			<download-fixtures-link />
			<search-icon class="visible-desktop" />
		</div>
		<portal to="fullscreen">
			<overlay-menu
				v-show="showOverlayMenu"
				@close="showOverlayMenu = false"
			></overlay-menu>
		</portal>
	</header>
</template>

<script>
import NotificationsIcon from "../Notifications/Icon.vue";
import SearchIcon from "../Search/Icon.vue";
import TopSessionButton from "./TopSessionButton.vue";
import OverlayMenu from "./OverlayMenu.vue";
import DownloadFixturesLink from "../DownloadFixtures/Link.vue";
import LanguageSelector from "./LanguageSelector.vue";
import ToggleButton from "./ThemeToggleButton.vue";
import NewBadge from "../Shared/NewBadge.vue";
import NotificationBanner from "../../components/Shared/NotificationBanner.vue";

export default {
	name: "Top",
	props: {
		showTopNav: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		NotificationsIcon,
		TopSessionButton,
		OverlayMenu,
		SearchIcon,
		DownloadFixturesLink,
		LanguageSelector,
		ToggleButton,
		NewBadge,
		NotificationBanner,
	},
	data() {
		return {
			option: "",
			balanceSet: false,
			numberOfLiveMatches: 0,
			numberOfBetBuilderMatches: 0,
			loggedIn: false,
			showOverlayMenu: false,

			hasMessage: false,
			message: null,
		};
	},
	computed: {
		betSlipCount() {
			return (
				this.$store.getters.betSlipCount +
				this.$store.getters.jengabetBetSlipCount +
				this.$store.getters.virtualBetslipCount
			);
		},

		balance() {
			return this.$store.getters.balance;
		},
		isAuthenticated() {
			return this.$auth.getAuthStatus();
		},
	},

	beforeMount() {
		let vm = this;
		vm.loggedIn = JSON.parse(window.localStorage.getItem("authenticated"));
		vm.getTotals();
		setInterval(() => {
			if (vm.$store.getters["settings/settings"].autorefresh.status)
				vm.getTotals();
		}, 10000);

		vm.hasMessage = localStorage.hasOwnProperty("notification-banner-message");
		if (localStorage.hasOwnProperty("notification-banner-message") === true) {
			vm.message = JSON.parse(
				localStorage.getItem("notification-banner-message")
			);
		}
	},

	watch: {
		$route: function() {
			this.loggedIn = JSON.parse(window.localStorage.getItem("authenticated"));
		},
	},
	methods: {
		getTotals() {
			let vm = this;
			this.$axios
				.get(`${BASE_URL}uo/totalMatches`)
				.then((response) => {
					if (response.data) {
						this.numberOfLiveMatches = response.data.total_live_matches;
						this.numberOfBetBuilderMatches =
							response.data.total_shikisha_matches;
						vm.$store.commit(
							"setNumberOfLiveMatches",
							response.data.total_live_matches
						);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		},
		goToApp() {
			try {
				fbq("trackCustom", "clickGoToAppFromNav");
			} catch (e) {
				console.warn("[TRACK] Could not track");
			}
			this.$refs.appLink.click();
		},

		goTo(location, option, isDataHeavy = false) {
			let vm = this;
			try {
				fbq("trackCustom", "clickTopNav", { route: location, name: option });
			} catch (error) {
				console.log("tracking error");
			}
			if (isDataHeavy) {
				vm.$store.commit("dataNotifier/setNext", {
					nextType: "cb",
					nextCb: () => {
						vm.option = option;
						vm.$router.push(location);
					},
				});
				vm.$store.commit("dataNotifier/toggleShow");
			} else {
				vm.option = option;
				vm.$router.replace(location);
			}
		},

		// Rerirects user to url specified in the notification banner's actionUrl value
		bannerNotificationAction(url) {
			let vm = this;
			if (url.length > 0) {
				vm.$router.push(url);
			}
			if (localStorage.hasOwnProperty("notification-banner-message") === true) {
				localStorage.removeItem("notification-banner-message");
			}
		},
	},
};
</script>

<style lang="scss">
.position-top-toggle {
	margin-top: 5px;
	margin-right: 21px;
}
header {
	display: flex;
	flex-direction: column;
	position: fixed;
	top: 0;
	width: 100%;
	background: var(--light-gray);
	max-width: var(--app-width);
	min-width: 320px;
	z-index: 99999;

	.topnav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		color: var(--black);
		font-size: var(--font-medium);
		background: var(--white);
		padding: 10px;
		padding-bottom: 3px;

		&.showborder {
			border-bottom: 1px solid var(--light-gray);
			padding-bottom: 10px;
		}

		&__left {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		&__menu {
			background: none;
			border: none;
			padding-left: 0px;
			padding-right: 10px;
			line-height: 0;

			svg {
				fill: var(--light-black);
				padding-left: 0px;
				height: 25px;
			}
		}
		&__logo {
			display: flex;
			flex-direction: row;
			align-items: center;
		}

		&__right {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		&__session {
			&__links {
				display: flex;
				flex-direction: row;
				&__item {
					padding: 5px;
					text-align: center;
					cursor: pointer;
					font-size: var(--font-medium);
					font-weight: var(--font-weight-lighter);
					display: flex;
					flex-direction: row;
					align-items: center;
					text-decoration: none;
					color: var(--black);
					white-space: nowrap;
					margin-right: 10px;
					&__icon {
						height: 20px;
						stroke: var(--black);
						margin-right: 5px;
					}
					&.active {
						color: var(--green);
						font-weight: var(--font-weight-medium);

						.topnav__session__links__item__icon > path,
						circle,
						rect {
							stroke: var(--green);
							stroke-width: 1.8px;
						}
					}
				}
			}
		}
	}

	.nav {
		display: flex;
		flex-direction: row;
		overflow: auto;
		overflow-y: hidden; // hide vertical
		transition: display 800ms ease;
		width: 100%;

		&::-webkit-scrollbar {
			display: none;
		}
		&__container {
			display: flex;
			justify-content: space-between;
			background: var(--white);
		}

		&--item {
			display: block;
			border: none;
			display: flex;
			position: relative;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;
			padding: 10px 15px;
			font-size: var(--font-medium);
			white-space: nowrap;
			color: var(--light-black);
			border-bottom: 3px solid var(--white);
			text-decoration: none;
			font-weight: var(--font-weight-lighter);
			@media (min-width: 1023px) {
				padding: 10px;
				font-size: var(--font-normal);
				cursor: pointer;
			}
			&.selected {
				border-bottom-color: var(--green);
				color: var(--green);
				font-weight: var(--font-weight-bold);
			}
		}
	}
}
</style>
